import kebabCase from "lodash/kebabCase";
import { v4 } from "uuid";
import { reaction } from "~/schemas/schema.reactions.jsx";
import * as actionTypes from "~/store/action_types";
import { makeGetReactionIdAddedByLoggedUserId } from "~/store/selectors/selector.reactions.jsx";
import { getLoggedUserId } from "~/store/selectors/selector.users.jsx";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const addReaction = (type, parentType, parentId, loggedUserId, id = v4()) => {
  const kebabParentType = kebabCase(parentType);

  return {
    types: [actionTypes.ADD_REACTION_LOADING, actionTypes.ADD_REACTION_SUCCESS, actionTypes.ADD_REACTION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/reactions/${kebabParentType}/${parentId}`,
        method: `POST`,
        body: {
          type,
        },
      }),
    payload: {
      reactionType: type,
      parentType,
      parentId,
      id,
      createdById: loggedUserId,
      schema: {
        single: reaction,
      },
    },
  };
};

export const removeReaction = (type, parentType, parentId, reactionId) => {
  const kebabParentType = kebabCase(parentType);

  return {
    types: [
      actionTypes.REMOVE_REACTION_LOADING,
      actionTypes.REMOVE_REACTION_SUCCESS,
      actionTypes.REMOVE_REACTION_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/reactions/${kebabParentType}/${parentId}`,
        method: `DELETE`,
        body: {
          type,
        },
      }),
    payload: {
      reactionType: type,
      parentType,
      parentId,
      reactionId,
    },
  };
};

export const toggleReaction = (type, parentType, parentId) => (dispatch, getState) => {
  const getReactionIdAddedByLoggedUserId = makeGetReactionIdAddedByLoggedUserId(type);
  const reactionId = getReactionIdAddedByLoggedUserId(getState(), parentType, parentId);
  const loggedUserId = getLoggedUserId(getState());

  if (reactionId) {
    return dispatch(removeReaction(type, parentType, parentId, reactionId));
  }

  return dispatch(addReaction(type, parentType, parentId, loggedUserId));
};

export const addReactionFromEventStream = (data) => {
  return {
    type: actionTypes.ADD_REACTION_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: reaction,
    reactionType: data.class,
    parentType: data.parent_type,
    parentId: data.parent_id,
  };
};

export const removeReactionFromEventStream = (data) => {
  return {
    type: actionTypes.REMOVE_REACTION_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: reaction,
    reactionType: data.class,
    parentType: data.parent_type,
    parentId: data.parent_id,
  };
};
